import { normalizeAccountId } from '../../routes/dashboard/crm/crm-host-protocol.js';

const OPPORTUNITY_ID_PATTERN = /^[A-Za-z0-9_-]{1,200}$/u;
let pendingOpportunity = null;

function normalizeOpportunityId(value) {
  if (typeof value !== 'string') return null;
  const normalized = value.trim();
  return OPPORTUNITY_ID_PATTERN.test(normalized) ? normalized : null;
}

export function setPendingCrmOpportunity(accountId, opportunityId) {
  const normalizedAccountId = normalizeAccountId(accountId);
  const normalizedOpportunityId = normalizeOpportunityId(opportunityId);
  if (!normalizedAccountId || !normalizedOpportunityId) return false;
  pendingOpportunity = {
    accountId: normalizedAccountId,
    opportunityId: normalizedOpportunityId,
  };
  return true;
}

export function consumePendingCrmOpportunity(accountId) {
  const normalizedAccountId = normalizeAccountId(accountId);
  const pending = pendingOpportunity;
  pendingOpportunity = null;
  return pending?.accountId === normalizedAccountId
    ? pending.opportunityId
    : null;
}
